module.exports = "/cyber/_next/static/images/bgTablet-58dc75b5cbdd4e70c3eea1d8697be38b.jpg";